module.exports = __webpack_public_path__ + "img/mastercard-dark-large.02f53791.svg";